<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
  <p>There are two directives that can make a group of buttons behave like a set of checkboxes, radio
  buttons, or a hybrid where radio buttons can be unchecked.</p>
  <p>The easiest way to add the buttons component to your app (will be added to the root module)</p>
  <pre class="prettyprint lang-bash prettyprinted"><span class="pln">ng add ngx</span><span class="pun">-</span><span class="pln">bootstrap </span> --component <span class="pln">buttons</span></pre>
  <docs-section [content]="componentContent"></docs-section>
</demo-section>
